import React, { useState } from 'react';
import { Navbar } from '../components/Navbar';
import { StickyFooter } from '../components/StickyFooter';
import { MailIcon, PhoneIcon, MapPinIcon, SendIcon } from 'lucide-react';
export function Contact() {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };
  return <div className="min-h-screen w-full bg-white flex flex-col" data-id="element-763">
      <Navbar data-id="element-764" />
      <main className="flex-1" data-id="element-765">
        <section className="w-full bg-gray-50 py-16 lg:py-24 border-b border-gray-100" data-id="element-766">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-767">
            <h1 className="text-4xl sm:text-5xl font-extrabold text-text-dark tracking-tight mb-6" data-id="element-768">
              Contact Us
            </h1>
            <p className="text-lg text-text-muted max-w-2xl mx-auto leading-relaxed" data-id="element-769">
              We're here to help. Get in touch with our team for support,
              inquiries, or feedback.
            </p>
          </div>
        </section>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-770">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-771">
            {/* Contact Info */}
            <div className="space-y-8" data-id="element-772">
              <div data-id="element-773">
                <h2 className="text-2xl font-bold text-text-dark mb-4" data-id="element-774">
                  Get in Touch
                </h2>
                <p className="text-text-muted leading-relaxed" data-id="element-775">
                  Whether you're a facility looking to fill shifts or a
                  healthcare professional seeking opportunities, our team is
                  ready to assist you.
                </p>
              </div>

              <div className="space-y-6" data-id="element-776">
                <div className="flex items-start gap-4" data-id="element-777">
                  <div className="w-12 h-12 bg-soft-teal rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-778">
                    <PhoneIcon className="w-6 h-6 text-medical-blue" data-id="element-779" />
                  </div>
                  <div data-id="element-780">
                    <h3 className="font-bold text-text-dark" data-id="element-781">Phone</h3>
                    <p className="text-text-muted mt-1" data-id="element-782">1-800-555-1234</p>
                    <p className="text-sm text-text-muted mt-1" data-id="element-783">
                      Available 24/7 for urgent staffing needs
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-784">
                  <div className="w-12 h-12 bg-soft-teal rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-785">
                    <MailIcon className="w-6 h-6 text-medical-blue" data-id="element-786" />
                  </div>
                  <div data-id="element-787">
                    <h3 className="font-bold text-text-dark" data-id="element-788">Email</h3>
                    <p className="text-text-muted mt-1" data-id="element-789">
                      support@carenomad.com
                    </p>
                    <p className="text-sm text-text-muted mt-1" data-id="element-790">
                      We typically respond within 2 hours
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-791">
                  <div className="w-12 h-12 bg-soft-teal rounded-xl flex items-center justify-center flex-shrink-0" data-id="element-792">
                    <MapPinIcon className="w-6 h-6 text-medical-blue" data-id="element-793" />
                  </div>
                  <div data-id="element-794">
                    <h3 className="font-bold text-text-dark" data-id="element-795">Headquarters</h3>
                    <p className="text-text-muted mt-1" data-id="element-796">
                      123 Healthcare Ave, Suite 400
                    </p>
                    <p className="text-text-muted" data-id="element-797">Toronto, ON M5V 3A8</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="bg-white rounded-2xl shadow-float border border-gray-100 p-8" data-id="element-798">
              <h3 className="text-xl font-bold text-text-dark mb-6" data-id="element-799">
                Send us a message
              </h3>

              {submitted ? <div className="bg-soft-teal rounded-xl p-8 text-center" data-id="element-800">
                  <div className="w-16 h-16 bg-accent-teal rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-801">
                    <SendIcon className="w-8 h-8 text-white" data-id="element-802" />
                  </div>
                  <h4 className="text-xl font-bold text-text-dark mb-2" data-id="element-803">
                    Message Sent!
                  </h4>
                  <p className="text-text-muted" data-id="element-804">
                    Thank you for reaching out. A member of our team will get
                    back to you shortly.
                  </p>
                  <button onClick={() => setSubmitted(false)} className="mt-6 text-medical-blue font-semibold hover:underline" data-id="element-805">
                    Send another message
                  </button>
                </div> : <form onSubmit={handleSubmit} className="space-y-4" data-id="element-806">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-807">
                    <div data-id="element-808">
                      <label htmlFor="firstName" className="block text-sm font-semibold text-text-dark mb-1.5" data-id="element-809">
                        First Name
                      </label>
                      <input type="text" id="firstName" required className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-medical-blue focus:outline-none text-text-dark transition-colors" placeholder="Jane" data-id="element-810" />
                    </div>
                    <div data-id="element-811">
                      <label htmlFor="lastName" className="block text-sm font-semibold text-text-dark mb-1.5" data-id="element-812">
                        Last Name
                      </label>
                      <input type="text" id="lastName" required className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-medical-blue focus:outline-none text-text-dark transition-colors" placeholder="Doe" data-id="element-813" />
                    </div>
                  </div>

                  <div data-id="element-814">
                    <label htmlFor="email" className="block text-sm font-semibold text-text-dark mb-1.5" data-id="element-815">
                      Email Address
                    </label>
                    <input type="email" id="email" required className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-medical-blue focus:outline-none text-text-dark transition-colors" placeholder="jane@example.com" data-id="element-816" />
                  </div>

                  <div data-id="element-817">
                    <label htmlFor="subject" className="block text-sm font-semibold text-text-dark mb-1.5" data-id="element-818">
                      Subject
                    </label>
                    <select id="subject" className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-medical-blue focus:outline-none text-text-dark transition-colors bg-white" data-id="element-819">
                      <option data-id="element-820">I'm a facility looking for staff</option>
                      <option data-id="element-821">
                        I'm a healthcare worker looking for shifts
                      </option>
                      <option data-id="element-822">General Inquiry</option>
                      <option data-id="element-823">Support</option>
                    </select>
                  </div>

                  <div data-id="element-824">
                    <label htmlFor="message" className="block text-sm font-semibold text-text-dark mb-1.5" data-id="element-825">
                      Message
                    </label>
                    <textarea id="message" rows={4} required className="w-full px-4 py-3 rounded-xl border-2 border-gray-200 focus:border-medical-blue focus:outline-none text-text-dark transition-colors resize-none" placeholder="How can we help you?" data-id="element-826"></textarea>
                  </div>

                  <button type="submit" className="w-full bg-medical-blue hover:bg-medical-blue-dark text-white font-bold py-3.5 rounded-xl transition-colors flex items-center justify-center gap-2" data-id="element-827">
                    <SendIcon className="w-4 h-4" data-id="element-828" />
                    Send Message
                  </button>
                </form>}
            </div>
          </div>
        </div>
      </main>
      <StickyFooter data-id="element-829" />
    </div>;
}